<template>
	<v-row>
		<v-col cols="3">
			<v-text-field label="Rua" v-model="iniciado.comercial.rua" outlined></v-text-field>
        </v-col>
        <v-col cols="1">
			<v-text-field label="Numero" v-model="iniciado.comercial.numero" outlined></v-text-field>
        </v-col>
        <v-col cols="1">
			<v-text-field label="Compl" v-model="iniciado.comercial.complemento" outlined></v-text-field>
        </v-col>
		<v-col cols="2">
			<v-text-field label="Bairro" v-model="iniciado.comercial.bairro" outlined></v-text-field>
        </v-col>
		<v-col cols="3">
			<v-text-field label="cidade" v-model="iniciado.comercial.cidade" outlined></v-text-field>
        </v-col>
		<v-col cols="2">
			<v-text-field label="estado" v-model="iniciado.comercial.estado" outlined></v-text-field>
        </v-col>
		<v-col cols="3">
			<v-select :items="this.listaPaises" v-model="iniciado.comercial.pais" label="País" outlined></v-select>
        </v-col>
		<v-col cols="3">
			<v-text-field label="Cep" v-model="iniciado.comercial.cep" outlined></v-text-field>
        </v-col>
		<v-col cols="3">
			<v-text-field label="Fone" v-model="iniciado.comercial.fone" outlined></v-text-field>
        </v-col>
	</v-row>
</template>
<script>
import { mapState } from 'vuex'
	export default{
		props:[],
		computed:{
			...mapState(['iniciado', 'listaPaises']),
		},
		data(){
			return{
			
			}
		},
		
		created(){
			
		}
	}
</script>
<style scoped>
	
</style>